import { createPatchEndpoint } from '@sonar-software/sonar-http';

export type PatchInitiativeFileRequest = {
	id: number;
	initiativeId: number;
	name?: string;
};

export const patchInitiativeFile = createPatchEndpoint<PatchInitiativeFileRequest>(
	({ id, initiativeId, name }) =>
		`/api/v3/initiatives/${initiativeId}/files/${id}?name=${encodeURIComponent(name ?? '')}`
);
